import axios from "axios";

export async function updateUserFlag(bmOrTag) {
  if (!bmOrTag) {
    console.log("bmOrTag value in function call is required");
    return;
  }
  const uri = "/profile/flag/update";
  const user_flag =
    bmOrTag === "bm_user_flag"
      ? "has_bookmarked_stories"
      : bmOrTag === "tag_user_flag"
      ? "has_followed_tags"
      : bmOrTag === "comments_user_flag"
      ? "has_enabled_comments"
      : bmOrTag === "toggle_tags"
      ? "has_personalized_content_disabled"
      : "";
  if (user_flag) {
    await axios
      .post(uri, {
        flag_name: user_flag,
        flag_value: "1",
      })
      .then((res) => console.log("response", res))
      .catch((err) => console.log(err));
  }
}
